import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { Product, BudgetCategory, RootProductId } from "@models";
import { escapeCategoryId } from "../util";
import BudgetCategoryAmounts from "./BudgetCategoryAmounts";
import CategoriesSelection from "./CategoriesSelection";
import { ConfigModuleSetting } from "./types";
import UserDetailsPageContext from "../../../../pages/user/UserDetailsPageContext";

type Props = {
	category: BudgetCategory;
	product: Product;
};

export default function BudgetCategoryDetails(props: Props) {
	const { product, category } = props;

	const { watch } = useFormContext<ConfigModuleSetting>();

	const namePrefix = `amounts.${escapeCategoryId(category.id)}` as const;
	const isActive: boolean = watch(`${namePrefix}.enabled`);
	const productsWithCategories: RootProductId[] = [
		"spend",
		"mobility",
		"fitAndRelax",
		"homeAndWork",
	];
	const hasCategories = productsWithCategories.includes(product.id);

	const { division } = useContext(UserDetailsPageContext);

	return (
		<div data-testid={`budgetCategorySection-${category.id}`}>
			{/* rather than conditionally mount this element, set it to hidden when inactive to avoid losing the edit values */}
			<div style={isActive ? undefined : { display: "none" }}>
				<BudgetCategoryAmounts productId={product.id} category={category} />
				{hasCategories && (
					<CategoriesSelection
						productId={product.id}
						budgetCategory={category}
						enabledCategories={division?.categories}
					/>
				)}
			</div>
		</div>
	);
}
